module.exports = __webpack_public_path__ + "img/uncomplete.76ee4b2f.svg";